const config = {
  environment: 'prod',
  api_url: 'https://api.hotglue.com',
};

export default config;
